export default __webpack_public_path__ + "static/media/players-tab.b99f132d.png";